import './style.scss'
// import { ACTIVITY_OPTIONS, ACTIVITY_TYPE } from '../../../constants/searchConstants';
import { ACTIVITY_TYPE } from '../../../constants/searchConstants';

interface InstructorProfileMiniDetailsProps {
	imgUrl: string
	name: string
	schoolName: string
	level: number
	activity?: number
	age?: string
	// gender?: string
}

// function InstructorProfileMiniDetails({imgUrl, name, schoolName, level, activity, age, gender}: InstructorProfileMiniDetailsProps) {
function InstructorProfileMiniDetails({imgUrl, name, schoolName, level, activity, age}: InstructorProfileMiniDetailsProps) {

	const getActivityLabel = (): string => {
		if (activity != undefined) {
			if (activity == 0) {
				return ACTIVITY_TYPE.SKIING
			} else if (activity == 1) {
				return ACTIVITY_TYPE.SNOWBOARDING
			} else if (activity == 2) {
				return `${ACTIVITY_TYPE.SKIING} & ${ACTIVITY_TYPE.SNOWBOARDING}`
			}
			// if (ACTIVITY_OPTIONS[Number(activity)].toLowerCase() == 'both') {
			// 	return `${ACTIVITY_TYPE.SKIING} & ${ACTIVITY_TYPE.SNOWBOARDING}`
			// } else {
			// 	return ACTIVITY_OPTIONS[Number(activity)]
			// }
		}
		return ACTIVITY_TYPE.SKIING
	}

	return (
		<div className="instructor-mini-details-wrap">
			{/* <div className="instructor-mini-details-img"> */}
				<img
					className="instructor-mini-details-img"
					src={imgUrl}
					alt={`Mini Profile`}
				/>
			{/* </div> */}
			<div className='instructor-mini-details-text-wrap'>
				<div className='instructor-mini-details-name'>{name}</div>
				{age && <div className='instructor-mini-details-school-name'>{age} Years Old</div>}
				{/* {gender && <div className='instructor-mini-details-school-name'>Gender: {gender}</div>} */}
				{activity != undefined && <div className='instructor-mini-details-school-name'>{getActivityLabel()}</div>}
				{schoolName.toLowerCase() != 'none' && <div className='instructor-mini-details-school-name'>School: {schoolName}</div>}
				<div className={`instructor-mini-details-level instructor-mini-details-level-${level}`}>Level {level}</div>
			</div>
		</div>
	)
}

export default InstructorProfileMiniDetails